export var IELTS_MODAL_SHOW = 'IELTS_MODAL_SHOW_ACTION';
export var IELTS_MODAL_HIDE = 'IELTS_MODAL_HIDE_ACTION';